import {
  HttpEvent,
  HttpEventType,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { CitywireInternalAccountsService } from '@tpapa/citywire-internal-accounts-angular';

@Injectable()
export class RBACInterceptor implements HttpInterceptor {
  constructor(private authService: CitywireInternalAccountsService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.authService.currentUser.pipe(
      take(1),
      switchMap((user) => {
        if (user) {
          request = request.clone({
            setHeaders: {
              username: user.username.toLowerCase(),
            },
          });
        }
        return next.handle(request);
      })
    );
  }
}
